// extracted by mini-css-extract-plugin
export default {"LogosItem":"UploadLogo_LogosItem__JZxR1","LogosItemLabel":"UploadLogo_LogosItemLabel__cKrIR"};